<template>
  <div class="appointment-types">
    <!-- <DIALOGS-->
    <!-- <APPOINTMENT TYPE CREATE OR UPDATE> -->
    <v-dialog v-model="cuDialog" width="850">
      <div style="background-color:white;">
        <appointment-type-c-u
          :isUpdate="isUpdate"
          :dialog="cuDialog"
          :appointmentTypeId="selectedAppointmentType"
          @closeDialog="closeDialog"
          @addedOrChanged="addedOrChanged"
        ></appointment-type-c-u>
      </div>
    </v-dialog>
    <!-- </APPOINTMENT TYPE CREATE OR UPDATE> -->
    <!--</DIALOGS-->
    <img v-if="isLoading" class="loading-icon" src="../../assets/loading-icon.gif" alt="Loading...">
    <div class="header clearAfterFloats">
      <h2 class="title">
        <h1 class="header-text">
          <span>Tipovi termina
            <div class="header-text-line"></div>
          </span>
        </h1>
      </h2>

      <!-- <APPOINTMENT TYPE SEARCH> -->
      <div class="appointmentType-search">
        <v-text-field class="search-field" v-model="searchText" label="Pretraga po nazivu"></v-text-field>

        <v-btn v-if="!isSearchActive" @click="filterByName" class="search-btn">
          <v-icon>search</v-icon>
          <span>Pretraga</span>
        </v-btn>

        <v-btn v-else @click="resetFilterObject" class="search-btn">
          <v-icon>close</v-icon>
          <span>Očisti pretragu</span>
        </v-btn>
      </div>
      <!-- </APPOINTMENT TYPE SEARCH> -->
      <img
        @click="cuDialog = true"
        src="../../assets/icons/create.png"
        class="action-icon-lg float-right"
        alt="Kreiraj"
      >
    </div>
    <!-- <APPOINTMENT TYPE DATA TABLE>-->
    <v-flex xs12>
      <v-data-table :headers="headers" :items="appointmentTypes" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Name }}</td>
          <td class="text-xs-left">
            <div class="color-container" :style="{backgroundColor: props.item.Color}"></div>
          </td>
          <td class="text-xs-center">
             <img
              @click="setAppointmentTypeForEdit(props.item.AppointmentTypeId)"
              src="../../assets/icons/edit.png"
              class="action-icon-sm"
              alt="Uredi"
            >
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <!-- </APPOINTMENT TYPE DATA TABLE> -->
  </div>
</template>

<script>
import AppointmentTypeCreateOrUpdate from "./CreateOrUpdate";
export default {
  components: {
    appointmentTypeCU: AppointmentTypeCreateOrUpdate
  },
  data() {
    return {
      //Data table headers
      headers: [
        {
          text: "Naziv",
          value: "naziv",
          align: "left"
        },
        {
          text: "Boja",
          value: "boja",
          align: "left"
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center"
        }
      ],
      appointmentTypes: [],
      //Dialogs
      cuDialog: false,

      //Helpers
      isUpdate: false,
      selectedAppointmentType: 0,
      isLoading: false,
      isSearchActive: false,
      searchText: ""
    };
  },
  methods: {
    closeDialog() {
      this.cuDialog = false;
      this.isUpdate = false;
    },
    getAppointmentTypes() {
      this.isLoading = true;
      this.$store.state.services.appointmentTypeService
        .getAll()
        .then(response => {
          this.appointmentTypes = response.data;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    setAppointmentTypeForEdit(selectedId) {
      this.selectedAppointmentType = selectedId;
      this.isUpdate = true;
      this.cuDialog = true;
    },
    addedOrChanged() {
      this.getAppointmentTypes();
      this.closeDialog();
    },
    filterByName() {
      if (this.searchText == "") return;

      this.isSearchActive = true;
      this.isLoading = true;
      this.$store.state.services.appointmentTypeService
        .filterByName(this.searchText)
        .then(response => {
          this.appointmentTypes = response.data;
          this.isLoading = false;
        });
    },
    resetFilterObject() {
      this.isSearchActive = false;
      this.searchText = "";

      this.getAppointmentTypes();
    }
  },
  created() {
    this.getAppointmentTypes();
  },
  watch:{
    cuDialog(){
      if(this.cuDialog == false){
        this.isUpdate = false;
      }
    }
  }
};
</script>

<style scoped>
.appointment-types {
  padding: 10px 30px;
  position: relative;
}

.title {
  width: 30%;
  float: left;
  font-size: 28px;
  color: #030405;
}

.appointmentType-search {
  width: 50%;
  float: left;
}

.search-field {
  width: 60%;
  float: left;
}

.search-btn {
  float: left;
  margin-left: 20px;
}

.color-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>
